import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { TacticalLabel } from './TacticalLabel';
import { Phone, Clock, MapPin, Mail, Shield } from 'lucide-react';
export function MissionForm() {
  const {
    scrollYProgress
  } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], [-100, 100]);
  return <section id="contact" className="relative py-24 overflow-hidden bg-sapper-dark" data-id="element-201">
      {/* Parallax Background */}
      <motion.div className="absolute inset-0 z-0" style={{
      y
    }} data-id="element-202">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1509316785289-025f5b846b35?q=80&w=2076&auto=format&fit=crop')] bg-cover bg-center opacity-40" data-id="element-203" />
        <div className="absolute inset-0 bg-sapper-dark/80" data-id="element-204" />
      </motion.div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10" data-id="element-205">
        <div className="mb-12 text-center max-w-3xl mx-auto" data-id="element-206">
          <TacticalLabel className="justify-center mb-4" data-id="element-207">
            INITIATE CONTACT
          </TacticalLabel>
          <h2 className="font-condensed font-bold text-5xl sm:text-6xl text-sapper-white uppercase tracking-tight mb-4" data-id="element-208">
            REQUEST YOUR MISSION BRIEFING
          </h2>
          <p className="font-sans text-lg text-sapper-gray" data-id="element-209">
            Same-day estimates. No pressure. No upsell games. Just straight
            answers.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-210">
          {/* Form */}
          <div className="lg:col-span-2 bg-[#141A15]/90 backdrop-blur-sm border border-sapper-olive/30 p-6 sm:p-8" data-id="element-211">
            <form className="space-y-6" data-id="element-212">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-213">
                <div className="space-y-2" data-id="element-214">
                  <label className="font-mono text-xs text-sapper-gray tracking-wider uppercase" data-id="element-215">
                    First Name
                  </label>
                  <input type="text" className="w-full bg-sapper-dark border border-sapper-olive/50 text-sapper-white px-4 py-3 focus:border-sapper-red focus:outline-none font-sans" data-id="element-216" />
                </div>
                <div className="space-y-2" data-id="element-217">
                  <label className="font-mono text-xs text-sapper-gray tracking-wider uppercase" data-id="element-218">
                    Last Name
                  </label>
                  <input type="text" className="w-full bg-sapper-dark border border-sapper-olive/50 text-sapper-white px-4 py-3 focus:border-sapper-red focus:outline-none font-sans" data-id="element-219" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-220">
                <div className="space-y-2" data-id="element-221">
                  <label className="font-mono text-xs text-sapper-gray tracking-wider uppercase" data-id="element-222">
                    Email
                  </label>
                  <input type="email" className="w-full bg-sapper-dark border border-sapper-olive/50 text-sapper-white px-4 py-3 focus:border-sapper-red focus:outline-none font-sans" data-id="element-223" />
                </div>
                <div className="space-y-2" data-id="element-224">
                  <label className="font-mono text-xs text-sapper-gray tracking-wider uppercase" data-id="element-225">
                    Phone
                  </label>
                  <input type="tel" className="w-full bg-sapper-dark border border-sapper-olive/50 text-sapper-white px-4 py-3 focus:border-sapper-red focus:outline-none font-sans" data-id="element-226" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-227">
                <div className="space-y-2" data-id="element-228">
                  <label className="font-mono text-xs text-sapper-gray tracking-wider uppercase" data-id="element-229">
                    Service City
                  </label>
                  <select className="w-full bg-sapper-dark border border-sapper-olive/50 text-sapper-white px-4 py-3 focus:border-sapper-red focus:outline-none font-sans appearance-none" data-id="element-230">
                    <option value="" data-id="element-231">Select City...</option>
                    <option value="phoenix" data-id="element-232">Phoenix</option>
                    <option value="scottsdale" data-id="element-233">Scottsdale</option>
                    <option value="mesa" data-id="element-234">Mesa</option>
                    <option value="gilbert" data-id="element-235">Gilbert</option>
                    <option value="chandler" data-id="element-236">Chandler</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-237">
                  <label className="font-mono text-xs text-sapper-gray tracking-wider uppercase" data-id="element-238">
                    Service Type
                  </label>
                  <select className="w-full bg-sapper-dark border border-sapper-olive/50 text-sapper-white px-4 py-3 focus:border-sapper-red focus:outline-none font-sans appearance-none" data-id="element-239">
                    <option value="" data-id="element-240">Select Service...</option>
                    <option value="install" data-id="element-241">AC Replacement</option>
                    <option value="repair" data-id="element-242">AC Repair</option>
                    <option value="minisplit" data-id="element-243">Mini-Split Install</option>
                    <option value="maintenance" data-id="element-244">Maintenance</option>
                  </select>
                </div>
              </div>

              <div className="space-y-2" data-id="element-245">
                <label className="font-mono text-xs text-sapper-gray tracking-wider uppercase" data-id="element-246">
                  Tell us about your situation
                </label>
                <textarea rows={4} className="w-full bg-sapper-dark border border-sapper-olive/50 text-sapper-white px-4 py-3 focus:border-sapper-red focus:outline-none font-sans resize-none" data-id="element-247"></textarea>
              </div>

              <div className="space-y-4" data-id="element-248">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-249">
                  <div className="relative flex items-start pt-1" data-id="element-250">
                    <input type="checkbox" className="peer sr-only" data-id="element-251" />
                    <div className="w-5 h-5 border border-sapper-olive/50 bg-sapper-dark peer-checked:bg-sapper-red peer-checked:border-sapper-red transition-colors flex items-center justify-center" data-id="element-252">
                      <svg className="w-3 h-3 text-white opacity-0 peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-253">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-254" />
                      </svg>
                    </div>
                  </div>
                  <span className="font-sans text-xs text-sapper-gray group-hover:text-sapper-white transition-colors" data-id="element-255">
                    I agree to receive transactional SMS messages from Sapper
                    HVAC at the number provided. Reply STOP to opt out. Msg &
                    data rates may apply.
                  </span>
                </label>
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-256">
                  <div className="relative flex items-start pt-1" data-id="element-257">
                    <input type="checkbox" className="peer sr-only" data-id="element-258" />
                    <div className="w-5 h-5 border border-sapper-olive/50 bg-sapper-dark peer-checked:bg-sapper-red peer-checked:border-sapper-red transition-colors flex items-center justify-center" data-id="element-259">
                      <svg className="w-3 h-3 text-white opacity-0 peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-260">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-261" />
                      </svg>
                    </div>
                  </div>
                  <span className="font-sans text-xs text-sapper-gray group-hover:text-sapper-white transition-colors" data-id="element-262">
                    I agree to receive marketing SMS and email from Sapper HVAC.
                    Reply STOP to opt out. Msg & data rates may apply.
                  </span>
                </label>
              </div>

              <button type="button" className="w-full bg-sapper-red text-sapper-white font-condensed font-bold text-xl py-4 uppercase tracking-wider hover:bg-red-700 transition-colors" data-id="element-263">
                DEPLOY MY ESTIMATE REQUEST
              </button>
            </form>
          </div>

          {/* Right Rail */}
          <div className="bg-sapper-olive/20 border border-sapper-olive/50 p-6 sm:p-8 h-fit" data-id="element-264">
            <h3 className="font-condensed font-bold text-2xl text-sapper-white uppercase tracking-wide mb-8 border-b border-sapper-olive/30 pb-4" data-id="element-265">
              COMMAND CENTER
            </h3>

            <div className="space-y-8" data-id="element-266">
              <div data-id="element-267">
                <div className="flex items-center gap-3 mb-2" data-id="element-268">
                  <Phone className="w-5 h-5 text-sapper-red" data-id="element-269" />
                  <span className="font-mono text-sm text-sapper-gray tracking-wider" data-id="element-270">
                    DISPATCH
                  </span>
                </div>
                <a href="tel:4805550199" className="font-condensed font-bold text-3xl text-sapper-white hover:text-sapper-red transition-colors" data-id="element-271">
                  (480) 555-0199
                </a>
              </div>

              <div data-id="element-272">
                <div className="flex items-center gap-3 mb-2" data-id="element-273">
                  <Clock className="w-5 h-5 text-sapper-red" data-id="element-274" />
                  <span className="font-mono text-sm text-sapper-gray tracking-wider" data-id="element-275">
                    HOURS OF OP
                  </span>
                </div>
                <div className="font-sans text-sapper-white" data-id="element-276">
                  <div className="font-bold text-sapper-red mb-1" data-id="element-277">
                    24/7 Emergency Ops
                  </div>
                  <div data-id="element-278">Mon-Sat: 7AM - 7PM Standard</div>
                </div>
              </div>

              <div data-id="element-279">
                <div className="flex items-center gap-3 mb-2" data-id="element-280">
                  <MapPin className="w-5 h-5 text-sapper-red" data-id="element-281" />
                  <span className="font-mono text-sm text-sapper-gray tracking-wider" data-id="element-282">
                    AO (AREA OF OP)
                  </span>
                </div>
                <div className="font-sans text-sapper-white" data-id="element-283">
                  Phoenix Metro & Surrounding Valley
                </div>
              </div>

              <div data-id="element-284">
                <div className="flex items-center gap-3 mb-2" data-id="element-285">
                  <Mail className="w-5 h-5 text-sapper-red" data-id="element-286" />
                  <span className="font-mono text-sm text-sapper-gray tracking-wider" data-id="element-287">
                    COMMS
                  </span>
                </div>
                <a href="mailto:ops@sapperhvac.com" className="font-sans text-sapper-white hover:text-sapper-red transition-colors" data-id="element-288">
                  ops@sapperhvac.com
                </a>
              </div>

              <div className="pt-6 border-t border-sapper-olive/30" data-id="element-289">
                <div className="flex items-center gap-3" data-id="element-290">
                  <Shield className="w-5 h-5 text-sapper-gray" data-id="element-291" />
                  <span className="font-mono text-xs text-sapper-gray tracking-widest" data-id="element-292">
                    ROC #345678
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}